import React from 'react';
import { FilledIconContainer, IconContainer } from 'theming/tokens/components/icon';
const ListIcon = props => {
  if (props.variant === 'filled') {
    return /*#__PURE__*/React.createElement(FilledIconContainer, {
      fill: props.fill,
      size: props.size
    }, /*#__PURE__*/React.createElement("path", {
      d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM192,184H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16Zm0-48H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16Zm0-48H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16Z"
    }));
  }
  return /*#__PURE__*/React.createElement(IconContainer, props, /*#__PURE__*/React.createElement("line", {
    x1: "40",
    y1: "128",
    x2: "216",
    y2: "128",
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "40",
    y1: "64",
    x2: "216",
    y2: "64",
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "40",
    y1: "192",
    x2: "216",
    y2: "192",
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit"
  }));
};
export { ListIcon };